import React from "react";
import { getStatusMeta } from "../../config/statuses";

export default function StatusBadge({ status, className = "" }) {
  const meta = getStatusMeta(status);
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="status-badge">
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      <span
        className="font-mono-2 text-[10px] tracking-[0.18em] uppercase"
        style={{ color: meta.color }}
      >
        {meta.label}
      </span>
    </div>
  );
}
